<template>
  <div class="form-group">
    <label :for="name" class="bold mr-1" :class="{'text-info': hasValue}">
      {{ label }}:
    </label>

    <div class="row">
      <div class="col-lg-4">

        <select :name="'op_' + name" v-model="operator" class="form-control">
          <option v-for="operatorOption in operatorOptions" :value="operatorOption.id">{{ operatorOption.text }}</option>
        </select>

      </div>
      <div class="col-lg-8">
        <datepicker :name="name" v-model="modelValue"></datepicker>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {type: String, required: true},
    label: {type: String, required: true},
    operatorOptions: {type: Array, default: () => [
      {id: 'on', text: 'On date'},
      {id: 'after', text: 'After'},
      {id: 'before', text: 'Before'},
    ]},
    operatorValue: {type: String, default: 'on'},
    value: {type: String, default: ''},
  },

  /**
   * Variables (models).
   */
  data () {
    return {
      modelValue: this.value,
      operator: this.operatorValue ?? 'on',
    }
  },

  /**
   * Computed values
   */
  computed: {

    hasValue() {
      return (this.value !== null) && (this.value !== '');
    }

  },

  /**
   * Functions (methods).
   */
  methods: {
  },
}
</script>
